import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { MainLayout } from "../layouts/MainLayout";

const HomePage = lazy(() => import("../pages/HomePage"));
const HireMePage = lazy(() => import("../pages/HireMePage"));
const ProjectsIndexPage = lazy(() => import("../pages/ProjectsIndexPage"));
const ProjectDetailPage = lazy(() => import("../pages/ProjectDetailPage"));
const BlogIndexPage = lazy(() => import("../pages/BlogIndexPage"));
const BlogPostPage = lazy(() => import("../pages/BlogPostPage"));

function Fallback() {
  return <p className="bx-text-muted py-24 text-center">…</p>;
}

export function AppRouter() {
  return (
    <Suspense fallback={<Fallback />}>
      <Routes>
        <Route path="/" element={<Navigate to="/pt" replace />} />
        <Route path="/:lang" element={<MainLayout />}>
          <Route index element={<HomePage />} />
          <Route path="hire-me" element={<HireMePage />} />
          <Route path="projects" element={<ProjectsIndexPage />} />
          <Route path="projects/:slug" element={<ProjectDetailPage />} />
          <Route path="blog" element={<BlogIndexPage />} />
          <Route path="blog/:slug" element={<BlogPostPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/pt" replace />} />
      </Routes>
    </Suspense>
  );
}
